import { Box, Button, HStack } from "@chakra-ui/react";
import { IoAdd } from "react-icons/io5";
import CompanyProcessLists from "../components/companyProcessLists";
import CompanyProcessPlay from "../components/companyProcessPlay";
import CompanyProcessForm from "../components/companyProcessForm";
import Dialog from "@shared/components/dialog";
import useCompanyProcessPage from "@companyProcess/hooks/useCompanyProcessPage";
import useCompanyLogs from "../components/companyProcessLogs/useCompanyLogs";
import CompanyLogs from "../components/companyProcessLogs";

const CompanyProcessPage = () => {
    const { 
        companyProcess,
        isLogsOpen,
        companies,
        selectedItem,
        isOpenDrawer,
        selectedCompany,
        isOpenDialog,
        onCloseDilog,
        setIsOpenDrawer, 
        setIsLogsOpen,
        onPressEditItem, 
        onPressAddItem,
        onPressDeleteItem,
        setSelectedCompany,
        onCreateCompanyProcess,
        onUpdateCompanyProcess,
        onDeleteCompanyProcess,
        onUpdateCompanyProcessStatus
    } = useCompanyProcessPage()

    const { logButtonClicked, Logs } = useCompanyLogs({setIsLogsOpen});

    return (
        <Box display="flex">
            <CompanyProcessLists data={companies} onSelectItem={setSelectedCompany} selectedItem={selectedCompany}/>
            <Box w="100%" position="relative">
                <HStack position="sticky" h={14} top={14} zIndex={10} bg="gray.100" justifyContent="end">
                    <Button 
                        size="md" 
                        colorScheme="blue" 
                        leftIcon={<IoAdd color="white" size={22}/>} 
                        onClick={onPressAddItem}
                    >
                        Agregar
                    </Button>
                </HStack>
                <CompanyProcessPlay 
                    setSelectedProceso={logButtonClicked}
                    data={companyProcess}
                    onPressEdit={onPressEditItem}
                    onPressDelete={onPressDeleteItem}  
                    onChangeProcessStatus={onUpdateCompanyProcessStatus}
                />
            </Box>
            <CompanyProcessForm 
                isOpen={isOpenDrawer} 
                companies={companies}
                companyProcess={selectedItem}
                onClose={setIsOpenDrawer} 
                onCreateCompanyProcess={onCreateCompanyProcess}
                onUpdateCompanyProcess={onUpdateCompanyProcess}
            />
            <Dialog 
                isOpen={isOpenDialog} 
                onClose={onCloseDilog} 
                onConfirm={onDeleteCompanyProcess} 
                title="Eliminar proceso de empresa" 
                message="¿Desea eliminar el proceso de la empresa?"
            />
            <CompanyLogs onClose={setIsLogsOpen} logs={Logs} isOpen={isLogsOpen}/>
        </Box>
    )
}

export default CompanyProcessPage;